import { render, staticRenderFns } from "./SelectRole.vue?vue&type=template&id=6a84515c&scoped=true&"
import script from "./SelectRole.vue?vue&type=script&lang=js&"
export * from "./SelectRole.vue?vue&type=script&lang=js&"
import style0 from "./SelectRole.vue?vue&type=style&index=0&id=6a84515c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a84515c",
  null
  
)

export default component.exports